import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { global } from "./global";
import VueHtmlToPaper from "vue-html-to-paper";
import Print from "vue-print-nb-jeecg";
import vSelect from 'vue-select'

import "./registerServiceWorker";

import { lps } from "./global"; 

axios.defaults.baseURL = global.url;

axios.baseURL2 = global.url2;
axios.lpsURL = global.lps_url;

// Silently refresh an expired access token and retry the failed request.
// Concurrent 401s while a refresh is already in flight are queued instead
// of each firing their own refresh call (which would race: the first to
// land rotates the refresh token, the rest would then fail against the
// now-revoked one and incorrectly log the user out).
let isRefreshingToken = false;
let pendingRequests = [];

const resolvePendingRequests = (accessToken) => {
  pendingRequests.forEach(({ resolve }) => resolve(accessToken));
  pendingRequests = [];
};

const rejectPendingRequests = (error) => {
  pendingRequests.forEach(({ reject }) => reject(error));
  pendingRequests = [];
};

const clearSessionAndRedirectToLogin = () => {
  localStorage.clear();
  router.push("/login").catch(() => {});
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config: originalRequest, response } = error;

    // Auth endpoints (login/app_login/refresh/validate/resend/logout) handle
    // their own errors — a 401 there is never "the session needs refreshing".
    const isAuthEndpoint = originalRequest && originalRequest.url && originalRequest.url.includes("auth/");

    if (!response || response.status !== 401 || isAuthEndpoint || originalRequest._retriedAfterRefresh) {
      return Promise.reject(error);
    }

    const storedToken = JSON.parse(localStorage.getItem("token") || "null");
    const refreshToken = storedToken && storedToken.refresh_token;

    if (!refreshToken) {
      clearSessionAndRedirectToLogin();
      return Promise.reject(error);
    }

    originalRequest._retriedAfterRefresh = true;

    if (isRefreshingToken) {
      return new Promise((resolve, reject) => {
        pendingRequests.push({ resolve, reject });
      }).then((newAccessToken) => {
        originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;
        return axios(originalRequest);
      });
    }

    isRefreshingToken = true;

    return axios
      .post("/auth/refresh", { refresh_token: refreshToken })
      .then((res) => {
        const newToken = res.data.token;
        localStorage.setItem("token", JSON.stringify(newToken));
        resolvePendingRequests(newToken.access_token);

        originalRequest.headers["Authorization"] = "Bearer " + newToken.access_token;
        return axios(originalRequest);
      })
      .catch((refreshError) => {
        rejectPendingRequests(refreshError);
        clearSessionAndRedirectToLogin();
        return Promise.reject(refreshError);
      })
      .finally(() => {
        isRefreshingToken = false;
      });
  }
);

Vue.config.productionTip = false;

Vue.use(Print);

Vue.use(require("vue-moment"));

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    // 'https://admin.takafulbruneihub.com/assets/css/button.css'
    "https://tbdadmin.takafulbruneihub.com/assets/css/button.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

Vue.prototype.$lps = lps;

router.beforeEach((to, from, next) => {
  let allowed = ["login", "auth_otp"];

  if(allowed.includes(to.name) || localStorage.getItem("token")) {
    return next();
  }

  next("/login");
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
